// extracted by mini-css-extract-plugin
export default {"form-group":"Link_form-group__zyP-F","link":"Link_link__19qUX","smallFont":"Link_smallFont__cTmup","alwaysUnderline":"Link_alwaysUnderline__w1-AK"};